<template>
  <div id="app">
    <Header v-if="($route.name != 'Top') && ($route.name != 'Gameplay')"/>
    <vue-page-transition name="fade">
      <router-view />
    </vue-page-transition>
  </div>
</template>

<script>
import Header from "@/components/Header"
export default {
  name: "App",
  components: {
    Header
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  background-image: url("~@/assets/img/アセット 46@3x.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue